import { styled } from '@linaria/react';
import { LineChartStyleProps } from './interfaces';

export const StyledLineChart = styled.div<LineChartStyleProps>`
  height: ${({ height }) => height}px;
`;
